export default "__VITE_ASSET__1WA$B2iW__"